<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epigraph"> </p>
<p class="ep">Zvino kana ruoke rwako rworudyi richikugumbura rudimure ururase nokuti zvinotova nane kwauri kuti mutezo wako mumwe chete ufe panokuti muviri wako wose upinde mumoto usinggadzimi</p>
<p class="epc">(Matthew 5:30. Shona Bible)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?2d0bf6d8